/**
 * @typedef module:Media.MseVideoService.MseLogTypeEnum
 * @description Every value emitted by a subscription to 'start' is tagged with one of these values,
 *     which clients can use to process the values
 * @property {String} autoPlay
 * @property {String} badParams
 * @property {String} info
 * @property {String} init
 * @property {String} firstPacketReceived
 * @property {String} keepAliveConfirmed
 * @property {String} keepAliveFailed
 * @property {String} mediaError The player was not able to use the delivered packet
 * @property {String} mediaErrorAborted MediaError.MEDIA_ERR_ABORTED 1
 * @property {String} mediaErrorNetwork MediaError.MEDIA_ERR_NETWORK 2
 * @property {String} mediaErrorDecode MediaError.MEDIA_ERR_DECODE 3
 * @property {String} mediaErrorSrcNotSupported MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED 4
 * @property {String} notAuthorized
 * @property {String} offline
 * @property {String} socketCreated
 * @property {String} socketOpenConfirmed
 * @property {String} socketOpenFailed
 * @property {String} socketInitRequested
 * @property {String} socketInitConfirmed
 * @property {String} socketClosed
 * @property {String} socketCreateFailed
 * @property {String} socketError
 * @property {String} sourceBufferError
 * @property {String} streamStartRequested
 * @property {String} streamStartConfirmed
 * @property {String} streamStartFailed
 * @property {String} viewerSessionCreated
 * @property {String} viewerSessionFailed
 * @property {String} videoError
 * @property {String} videoPlaying
 */

const MseLogTypeEnum = Object.freeze({
    autoPlay: 'autoPlay',
    badParams: 'badParams',
    badServerResponse: 'badServerResponse',
    info: 'info',
    init: 'init',
    firstPacketReceived: 'firstPacketReceived',
    keepAliveConfirmed: 'keepAliveConfirmed',
    keepAliveFailed: 'keepAliveFailed',
    mediaError: 'mediaError',
    mediaErrorAborted: 'mediaErrorAborted',
    mediaErrorNetwork: 'mediaErrorNetwork',
    mediaErrorDecode: 'mediaErrorDecode',
    mediaErrorSrcNotSupported: 'mediaErrorSrcNotSupported',
    notAuthorized: 'notAuthorized',
    offline: 'offline',
    socketCreated: 'socketCreated',
    socketOpenConfirmed: 'socketOpenConfirmed',
    socketOpenFailed: 'socketOpenFailed',
    socketInitRequested: 'socketInitRequested',
    socketInitConfirmed: 'socketInitConfirmed',
    socketClosed: 'socketClosed',
    socketCreateFailed: 'socketCreateFailed',
    socketError: 'socketError',
    sourceBufferError: 'sourceBufferError',
    streamStartRequested: 'streamStartRequested',
    streamStartConfirmed: 'streamStartConfirmed',
    streamStartFailed: 'streamStartFailed',
    viewerSessionCreated: 'viewerSessionCreated',
    viewerSessionFailed: 'viewerSessionFailed',
    videoError: 'videoError',
    videoPlaying: 'videoPlaying'
});

export default MseLogTypeEnum;
